import React, { useState, useEffect } from "react";
import Navbar from "../../Company/About/Navbar";
import Footer from "../../Company/About/Footer";
import Hero from "../../Company/CompanyHome/Hero";
import { useLocation } from "react-router";
import CandidateList from "./CandidateList";
import { useNavigate } from "react-router";

const Resultv2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const jobId = new URLSearchParams(location.search).get("jobID");
  const len = location.state.len;
  console.log("len", len);
  const [rankings, setRankings] = useState([]);
  const [score, setScore] = useState(0);
  const [jobDetails, setJobDetails] = useState({
    job_title: 'Software Engineer',
    location: 'Mumbai',
    experience_range: '5 - 7 yrs'
  });
  const [candidates, setCandidates] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const candidatesPerPage = 5;
  const totalPages = Math.ceil(candidates.length / candidatesPerPage);
  const [loading, setLoading] = useState(true);


  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return date.toISOString().split("T")[0]; // "2025-03-04"
  // };

  // Fetch function
  const fetchTestResults = async (jobId) => {
    try {
      const response = await fetch(`/api/view_test_results?jobId=${jobId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch test results");
      }

      const data = await response.json();
      const results = data.results;
      console.log(results)
      setJobDetails(data.job_details);
      if (!results || results.length === 0) {
        alert("No test results found");
      }
      // Map results to the desired format
      const formattedRankings = results.map((result, index) => ({

        // rank: `${index + 1}${["st", "nd", "rd"][index] || "th"}`,
        rank: index + 1,
        scores: [
          { score: result.screening_score != null ? `${result.screening_score}/100` : result.screening_test_scheduled_time ? `Scheduled` : 'Not Scheduled', 
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/b01e2a09-4cb7-4481-b1a6-c2970698aef6?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214", 
            color: "#D0E6FF"
          },
          {
            score: result.personality_score != null ? `${result.personality_score}/100` : result.personality_test_scheduled_time ? `Scheduled` : 'Not Scheduled',
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/424247ed-4559-4d16-84a4-8bed0e7cd6f9?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214",
            color: "#D4F7FF"
          },
          {
            score: result.behavioral_score != null ? `${result.behavioral_score}/100` : result.behavioral_test_scheduled_time ? `Scheduled` : 'Not Scheduled',
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/a1cfb3f3-3ec9-4bf2-9d5d-07345cca0ce3?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214",
            color: "#CCFAD7"
          },
          { score: result.coding_score != null ? `${result.coding_score}/100` : result.coding_test_scheduled_time ? `Scheduled` : 'Not Scheduled', icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/fcac6ea6-8e51-42a2-a036-e3b4e2308486?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214", color: "#FED9B4" }
        ],
        email: result.user_email || `Candidate ${index + 1}`,
        total_results: results.length,
        details: result // Store the full result for detailed view
      }));
      setScore(results[0].screening_score);
      setRankings(formattedRankings);
    }
    catch (error) {
      console.error("Error fetching test results:", error);
    }finally {
      setLoading(false); // stop loader
    }
  };

  // Fetch candidate list from the Flask API when component mounts.
  useEffect(() => {
    fetchTestResults(jobId);
  }, [jobId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const paginatedCandidates = candidates.slice(
    (currentPage - 1) * candidatesPerPage,
    currentPage * candidatesPerPage
  );

  if (loading) {
    return (
      <div className="loader-container11">
        <div className="spinner"></div>
      </div>
    );
  }
  

  return (
    <div className="min-h-screen w-full bg-background flex flex-col">
      <Navbar />
      <Hero />
      <div className="bg-background py-8">
      <div className="max-w-4xl mx-auto px-5">
          <div className="mb-4">
            <h2 className="text-2xl font-bold text-foreground">
              {jobDetails.job_title}
            </h2>
            
          </div>
      <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex items-center gap-2">
              <span>📍</span>
              <span className="text-sm text-muted-foreground">{jobDetails.location || 'Location not specified'}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>⏱️</span>
              <span className="text-sm text-muted-foreground">{jobDetails.experience_range || 'Experience not specified'}</span>
            </div>
            <div className="flex items-center gap-2">
              <span>🔢</span>
              <span className="text-sm text-muted-foreground">Job Code: {jobId}</span>
            </div>
          </div>
          </div>
        <div className="flex gap-2 justify-center mb-6">
          <button></button>
          <button className="px-4 py-2 rounded border border-border bg-background hover:bg-accent" onClick={() => { navigate(`/ranking?jobID=${jobId}`) }}>Applications</button>
          <button ></button>
          <button className="px-4 py-2 rounded border border-primary bg-primary text-primary-foreground" onClick={() => {
            navigate(`/results?jobID=${jobId}`, { state: { jobDetails: jobDetails, candidates: candidates } });
          }}>Interview Result</button>
          <button></button>
        </div>

        <input type="text" className="max-w-3xl mx-auto block px-4 py-2 border border-border rounded-md" style={{ width: '70%' }} placeholder="Search candidates" />

        <CandidateList candidates={paginatedCandidates} ranking={rankings} jobDetails={jobDetails} />
        <div className="flex gap-2 justify-center mt-6">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`px-4 py-2 rounded border ${currentPage === index + 1 ? "bg-primary text-primary-foreground border-primary" : "border-border bg-background hover:bg-accent"}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Resultv2;